"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsModal = void 0;
const react_1 = __importStar(require("react"));
const icons_1 = require("../../../theme/icons");
const buttons_1 = require("../../buttons");
const forms_1 = require("../../forms");
const global_1 = require("../../global");
const SettingsModal_styles_1 = require("./SettingsModal.styles");
const SettingsModal = ({ title, show, tabItems, close, translationKey, translationEditHandler, titleTranslationKey, }) => {
    const [active, setActive] = (0, react_1.useState)(0);
    tabItems.forEach((item, index) => (item.onClick = () => {
        setActive(index);
    }));
    (0, react_1.useEffect)(() => {
        const handleKeyDown = ({ key }) => {
            if (key === "Escape" || key === "Esc") {
                close();
            }
        };
        window.addEventListener("keydown", handleKeyDown, true);
        return () => {
            window.removeEventListener("keydown", handleKeyDown, true);
        };
    }, [close]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        show && react_1.default.createElement(SettingsModal_styles_1.ModalBackgroundWrapper, null),
        react_1.default.createElement(SettingsModal_styles_1.ModalWrapper, null,
            react_1.default.createElement(SettingsModal_styles_1.ModalContentWrapper, null,
                react_1.default.createElement(SettingsModal_styles_1.IconContainer, null,
                    react_1.default.createElement(global_1.IconWrapper, { hoverEffect: true, onClick: close },
                        react_1.default.createElement(icons_1.Close, { size: "small" }))),
                react_1.default.createElement(SettingsModal_styles_1.ModalHeader, null,
                    react_1.default.createElement(SettingsModal_styles_1.Title, { "$inlineTranslation": !!translationKey }, translationKey ? (react_1.default.createElement(forms_1.EditableTitle, { name: title, editHandler: (isCancelled, value) => translationEditHandler && value && translationEditHandler(isCancelled, value, titleTranslationKey), isEditable: !!translationKey })) : (title)),
                    react_1.default.createElement(SettingsModal_styles_1.HorizontalLine, null)),
                react_1.default.createElement(SettingsModal_styles_1.ModalBodyContainer, null,
                    react_1.default.createElement(buttons_1.TabGroup, { items: tabItems, activeIndex: active, fitContent: true }))))));
};
exports.SettingsModal = SettingsModal;
//# sourceMappingURL=SettingsModal.js.map